import Vue from "vue";
import axios from "axios";
import router from "../router";
import { Modal, message } from "ant-design-vue";
Vue.use(Modal);

//import store from '@/store'
// 统一错误反馈
const err = error => {
  //const token = Vue.ls.get('token')
  if (error.response) {
    if (error.response.status === 422) {
      message.info("参数错误");
    }
    if (error.response.status === 401) {
      Vue.ls.remove("token");
      router.push({ name: "login" });
    }
  }
  return Promise.reject(error);
};

// 校验 JWT 请求
const ajaxJWT = axios.create({
  timeout: 10000
});

ajaxJWT.interceptors.request.use(config => {
  const token = Vue.ls.get("SS");
  if (token) {
    config.headers.common["Authorization"] = `Bearer ${token}`;
  }
  return config;
}, err);

ajaxJWT.interceptors.response.use(response => {
  return response.data;
}, err);

// 正常 请求
const ajax = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 6000 // 请求超时时间
});

ajax.interceptors.request.use(config => {
  return config;
}, err);

ajax.interceptors.response.use(response => {
  return response.data;
}, err);

export { ajax, ajaxJWT };
